/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Commission,
  CreateCommissionsParams,
  GetUserEntityRevenueParams,
  HTTPValidationError,
  OrderCommissionRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create commissions
 * @summary Create Commissions
 */
export const createCommissions = (
  commission: Commission[],
  params: CreateCommissionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/commissions/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: commission,
    params,
    signal,
  });
};

export const getCreateCommissionsMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommissions>>,
    TError,
    { data: Commission[]; params: CreateCommissionsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommissions>>,
  TError,
  { data: Commission[]; params: CreateCommissionsParams },
  TContext
> => {
  const mutationKey = ["createCommissions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommissions>>,
    { data: Commission[]; params: CreateCommissionsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return createCommissions(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommissions>>
>;
export type CreateCommissionsMutationBody = Commission[];
export type CreateCommissionsMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Commissions
 */
export const useCreateCommissions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommissions>>,
      TError,
      { data: Commission[]; params: CreateCommissionsParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommissions>>,
  TError,
  { data: Commission[]; params: CreateCommissionsParams },
  TContext
> => {
  const mutationOptions = getCreateCommissionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get total commission revenue for a user entity.
 * @summary Get User Entity Revenue
 */
export const getUserEntityRevenue = (
  params?: GetUserEntityRevenueParams,
  signal?: AbortSignal,
) => {
  return customInstance<OrderCommissionRead[]>({
    url: `/api/commissions/revenue`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserEntityRevenueQueryKey = (
  params?: GetUserEntityRevenueParams,
) => {
  return [
    "api",
    "commissions",
    "revenue",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserEntityRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEntityRevenue>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUserEntityRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntityRevenue>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserEntityRevenueQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserEntityRevenue>>
  > = ({ signal }) => getUserEntityRevenue(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserEntityRevenue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserEntityRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserEntityRevenue>>
>;
export type GetUserEntityRevenueQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetUserEntityRevenue<
  TData = Awaited<ReturnType<typeof getUserEntityRevenue>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetUserEntityRevenueParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntityRevenue>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEntityRevenue>>,
          TError,
          Awaited<ReturnType<typeof getUserEntityRevenue>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEntityRevenue<
  TData = Awaited<ReturnType<typeof getUserEntityRevenue>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUserEntityRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntityRevenue>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEntityRevenue>>,
          TError,
          Awaited<ReturnType<typeof getUserEntityRevenue>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserEntityRevenue<
  TData = Awaited<ReturnType<typeof getUserEntityRevenue>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUserEntityRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntityRevenue>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Entity Revenue
 */

export function useGetUserEntityRevenue<
  TData = Awaited<ReturnType<typeof getUserEntityRevenue>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetUserEntityRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEntityRevenue>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserEntityRevenueQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
